import React from 'react'
import { useParams } from 'react-router'
import PageMeta from '../../../components/common/PageMeta'
import PageHeader from '../../../components/common/PageHeader'
import ProductResume from './ProductResume'
import { ProductTabs } from './Tabs/ProductTabs'

const ProductDetail = () => {
    const { id } = useParams<{ id: string }>()

    return (
        <>
            <PageMeta title='Produto | CRM' description='Dados do produto' />
            <PageHeader back />
            <div className='grid grid-cols-1 md:flex justify-between gap-3'>
                <div className='md:w-1/3'>
                    <ProductResume />
                </div>
                <div className='md:w-2/3'>
                    <ProductTabs />
                </div>
            </div>
        </>
    )
}

export default ProductDetail
